<!--
  画面名：-
  概要： 食材追加用データテーブル
  備考： -
-->

<!-- HTML -->
<template>

  <!--  チェックリストダイアログ要素  -->
  <v-dialog content-class="foodDialogWrapper" v-model="isFoodDialog" max-width="1400px">
    <!--  ページ全体を囲う要素  -->
    <div class="wrapper foodDialog">
      <!-- 食材/レシピデータテーブル -->
      <FoodDataList
        :isDialog="true"
        :isPlan="isPlan"
        :isOperation="isOperation"
        :cookingMaterial="cookingMaterial"
        ref="refFoodDataList"
        @checkSelection="checkSelection"
        @submit="submit"
        @callback="callback"
      />
      <v-card-actions>
        <v-spacer />
        <!-- 追加ボタン -->
        <v-btn
          color="blue darken-1"
          flat
          @click="sendFoodData"
        >
          {{$language.LabelAdd}}
        </v-btn>
        <!-- キャンセルボタン -->
        <v-btn
          color="blue darken-1"
          flat @click="closeDialog"
        >
          {{ $language.LabelClose }}
        </v-btn>
      </v-card-actions>
    </div>
    <!-- 食材登録用モーダル -->
    <FoodModal
      ref="foodModal"
      @send="reloadData"
      :isPlan="isPlan"
      v-if="!isOperation"
    />
  </v-dialog>
</template>
<!-- /HTML -->

<script>
// 食材データ一覧
import FoodDataList from '@/components/parts/common/FoodDataList'
// 食材登録用モーダル
import FoodModal from '@/components/parts/managementFunction/FoodModal'

export default {
  // 使用コンポーネント
  components: {
    // 食材データ一覧
    FoodDataList,
    // 食材登録用モーダル
    FoodModal
  },
  props: {
    // 料理で使用されている食材
    cookingMaterial: { type: Array, default: function () { return [] } },
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false },
    // オペレーションからの判定
    isOperation: { type: Boolean, default: false }
  },

  // 初期値設定
  data () {
    return {
      // ダイアログの表示切替
      isFoodDialog: false,
      isHide: false
    }
  },
  // コンポーネントの処理を記載
  methods: {
    // 選択されている種別をチェックする
    checkSelection (value) {
      if (value === 2) {
        this.isHide = true
      } else {
        this.isHide = false
      }
    },
    // ダイアログを表示する。親コンポーネントから発火。
    showDialog () {
      this.isFoodDialog = true
      this.$refs.refFoodDataList.getFoodData(true)
    },
    // 食材登録用モーダル表示処理
    loadDialog () {
      this.$refs.foodModal.loadDialog()
    },
    // ダイアログを閉じる
    closeDialog () {
      this.isFoodDialog = false
    },
    sendFoodData () {
      // 食材データをDBに送る
      this.$refs.refFoodDataList.sendCehcks()
    },
    // 料理登録の子コンポーネントに食材を追加する
    submit (value) {
      this.$emit('getSelectedData', value)
      this.closeDialog()
    },
    // 食材一覧のデータを更新する
    reloadData () {
      this.$refs.refFoodDataList.getFoodData(true)
    },
    // 親画面に完了を通達
    callback () {
      this.$emit('callback')
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/common/dialog.scss';
</style>
